import styled from 'styled-components';
import { COLOR, TYPOGRAPHY } from '../../../../theme/constants';

export const MetricsTableBodyContainer = styled.tbody``;

export const MetricsTableRowNull = styled.tr<{ rowStyle: string }>`
   ${props => {
      switch (props.rowStyle) {
         case 'S1':
            return `
          color: red;
          ${TYPOGRAPHY.BOLD};
        `;
         case 'S2':
            return `
          ${TYPOGRAPHY.BOLD};
        `;
      }
   }}
`;

export const MetricsTableRow = styled(MetricsTableRowNull)<{ index: number; padding: boolean }>`
   background: ${COLOR.WHITE};

   ${props =>
      props.index % 2
         ? ''
         : `
    background: #eff9ff;
  `}

   ${props =>
      props.padding
         ? `
    height: 15px;
  `
         : ''}
`;
